module.exports = __webpack_public_path__ + "static/media/Enterprise Level Collaboration.f4e29f5f.svg";